import { render, staticRenderFns } from "./MultiResourceModalContent.vue?vue&type=template&id=15c7ce5e"
import script from "./MultiResourceModalContent.vue?vue&type=script&lang=js"
export * from "./MultiResourceModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports